import { addError } from '@shared/utils/logger';
import { useCreateEventState } from '@shared/createEvent/CreateEventState';
import { useSetAndPublishThemeLayoutForCreateSurveyMutation } from '@graphql/generated';

export interface SetThemeProps {
  themeId: string;
}

export const useSetTheme = () => {
  const { addEventCreatedListener } = useCreateEventState();
  const [setAndPublishThemeAndLayout] = useSetAndPublishThemeLayoutForCreateSurveyMutation();

  const updateTheme = async ({ themeId }: SetThemeProps) => {
    addEventCreatedListener(async event => {
      const eventDesign = event.createEventV0301?.eventDesign;
      if (eventDesign) {
        try {
          await setAndPublishThemeAndLayout({
            variables: {
              themeAndLayoutPayload: {
                eventDesignId: eventDesign.id ?? '',
                layoutId: eventDesign.websiteLayout?.id ?? '',
                themeId,
                useSuggestedThemeColor: true
              },
              eventDesignId: eventDesign.id ?? ''
            }
          });
        } catch (error) {
          addError(error, {
            themeId,
            eventDesign
          });
        }
      }
    });
  };

  return updateTheme;
};
